<template>
  <div class="header-container">
    <template v-if="isPhoneWidth">
      <!--      <div class="header-phone-wrapper">-->
      <!--        <div class="header-phone-logo">-->
      <!--          <a href="/" style="color: white; text-decoration:none;">LKVAL</a>-->
      <!--        </div>-->
      <!--        <div class="header-phone-menu" @click="showPhoneMenu">-->
      <!--          <i class="iconfont icon-caidan"></i>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="header-phone-nav" v-show="phoneMenuVisible">-->
      <!--        <template v-for="(item, index) in ROUTER_LINKS">-->
      <!--          <router-link :to="item.link" tag="li"-->
      <!--                       :class="pathname===item.link? 'header-nav-li-active':''" :key="index" exact>-->
      <!--            {{ item.title }}-->
      <!--          </router-link>-->
      <!--        </template>-->
      <!--        &lt;!&ndash;        <div style="margin-bottom: 10px;"></div>&ndash;&gt;-->
      <!--        &lt;!&ndash;        <div class="header-streamer-title">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <button class="header-streamer-title-btn" onclick="window.open('https://space.bilibili.com/53619890')">&ndash;&gt;-->
      <!--        &lt;!&ndash;            B站主页:龍克&ndash;&gt;-->
      <!--        &lt;!&ndash;          </button>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
      <!--        <div style="margin-bottom: 10px;"></div>-->
      <!--        <template v-if="$store.state.userinfo.figureurl_qq_1">-->
      <!--          <el-dropdown @command="handleCommand">-->
      <!--            <div class="el-dropdown-link header-login-avatar">-->
      <!--              <el-avatar :src="$store.state.userinfo.figureurl_qq_1"></el-avatar>-->
      <!--              <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
      <!--            </div>-->
      <!--            <el-dropdown-menu slot="dropdown">-->
      <!--              <el-dropdown-item disabled>{{ $store.state.userinfo.nickname }}</el-dropdown-item>-->
      <!--              <el-dropdown-item command="editProfile">修改昵称</el-dropdown-item>-->
      <!--              <el-dropdown-item command="signOut" divided>退出登录</el-dropdown-item>-->
      <!--            </el-dropdown-menu>-->
      <!--          </el-dropdown>-->
      <!--        </template>-->
      <!--        <template v-else>-->
      <!--          <el-button type="primary" style="margin-right: 40px" size="small" @click="openQQLogin">-->
      <!--            QQ登录-->
      <!--          </el-button>-->
      <!--        </template>-->
      <!--      </div>-->

    </template>
    <template v-else>
      <div class="header-wrapper">
        <div class="header-logo">
          <a style="color: #000000; text-decoration:none;font-weight:800;">LK</a>
        </div>
        <ul class="header-nav">
          <template v-if="$store.state.userinfo.isAdmin">
            <router-link :to="'/'" tag="li"
                         :class="pathname==='/'? 'header-nav-li-active':''">
              道具点位
            </router-link>
          </template>

          <router-link v-if="$store.state.userinfo.isAdmin"
                       :to="'/discuss'" tag="li"
                       :class="pathname==='/discuss'? 'header-nav-li-active':''">
            {{ $store.state.currentPage === 'val' ? '上传点位' : '上传道具' }}
          </router-link>
          <router-link v-if="$store.state.userinfo.isAdmin"
                       :to="'/comment'" tag="li"
                       :class="pathname==='/comment'? 'header-nav-li-active':''">
            评论管理
          </router-link>
          <router-link v-if="$store.state.userinfo.isAdmin"
                       :to="'/lineup'" tag="li"
                       :class="pathname==='/lineup'? 'header-nav-li-active':''">
            点位管理
          </router-link>
        </ul>
        <!--        <el-divider direction="vertical"></el-divider>-->
        <div class="header-streamer-title">

          <!-- 游戏切换按钮组 -->
          <div class="game-switcher">
            <div class="button-group">
              <button
                  :class="['switch-btn', { active: $store.state.currentPage === 'val' }]"
                  @click="selectGame('val')"
              >
                <img :src="config.game.val.logoSrc" class="game-icon" alt="val"/>
                无畏契约
              </button>
              <button
                  :class="['switch-btn', { active: $store.state.currentPage === 'cs2' }]"
                  @click="selectGame('cs2')"
              >
                <img :src="config.game.cs2.logoSrc" class="game-icon" alt="CS2"/>
                CS2
              </button>
              <button
                  :class="['switch-btn', { active: $store.state.currentPage === 'df' }]"
                  @click="selectGame('df')"
              >
                <img :src="config.game.df.logoSrc" class="game-icon" alt="df"/>
                三角洲行动
              </button>
            </div>
          </div>

          <!-- 外部链接按钮 -->
          <div class="external-links">
            <a href="https://space.bilibili.com/53619890" target="_blank" class="external-link-btn">
              <img src="https://img.lkval.com/static/assets/BILI.png" alt="B站" class="external-link-icon"/>
              B站: 龍克
            </a>
            <a href="https://qm.qq.com/cgi-bin/qm/qr?k=2z9oo5Pvivh9TQwp6QbgnJkQfh1JtbC9&jump_from=webapi&authKey=7EtR3HvH2KqCzNosKCpAycy1zZjzXwl3QglFIV4TS41w+covNLAlUZJ5X8Lbzore"
               target="_blank" class="external-link-btn">
              <img src="https://img.lkval.com/static/assets/QQ.png" alt="QQ" class="external-link-icon"/>
              Q群: 545836520
            </a>
            <a href="#" class="external-link-btn" @click.prevent="showFeedback">
              <img src="https://img.lkval.com/static/assets/feedback.png" alt="反馈" class="external-link-icon"/>
              网站反馈
            </a>
          </div>

          <!-- 网站反馈对话框 -->
          <el-dialog
              title="网站反馈"
              :visible.sync="feedbackDialogVisible"
              width="500px"
              center
          >
            <el-form :model="feedbackForm" label-width="0">
              <el-form-item>
                <el-input
                    v-model="feedbackForm.content"
                    type="textarea"
                    :rows="4"
                    placeholder="有推荐的道具教学视频可以直接在这里粘贴链接提交！网站的BUG或者对网站有什么建议也可以提交，欢迎大家共同完善网站"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="feedbackDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
            </span>
          </el-dialog>
          <!--          <a onclick="window.open('https://space.bilibili.com/53619890')" style="margin-right: 20px">-->
          <!--            联系作者:龍克-->
          <!--          </a>-->

          <!--          <div class="live-card">-->
          <!--            <a onclick="window.open('https://www.douyu.com/8694')">-->
          <!--              冠名主播:Sideny蛇-->
          <!--            </a>-->
          <!--          </div>-->
        </div>
        <template v-if="$store.state.userinfo.figureurl_qq_1">
          <el-dropdown @command="handleCommand">
            <div class="el-dropdown-link header-login-avatar">
              <el-avatar :src="$store.state.userinfo.figureurl_qq_1"></el-avatar>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>{{ $store.state.userinfo.nickname }}</el-dropdown-item>
              <el-dropdown-item command="editProfile">修改昵称</el-dropdown-item>
              <el-dropdown-item command="signOut" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <!--          <el-button type="primary" style="margin-right: 40px" size="small" @click="openQQLogin">-->
          <!--            QQ登录-->
          <!--          </el-button>-->
        </template>
      </div>
    </template>

  </div>
</template>

<script>
import QC from 'QC'
import axios from 'axios'
import store from "@/store";
import {config} from "@/common/config";

const PHONE_WIDTH = 768
export default {
  name: "Header",
  data() {
    return {
      config,
      isPhoneWidth: false,
      isLive: false,
      phoneMenuVisible: false,
      pathname: '/',
      feedbackDialogVisible: false,
      feedbackForm: {
        content: ''
      }
    }
  },
  created() {
    this.handleWindowWidth()
    // window.addEventListener('resize', this.handleWindowWidth)
    // this.getLiveStatus()
  },

  destroyed() {
    // window.addEventListener('resize', this.handleWindowWidth)
  },
  watch: {
    $route(to, from) {
      this.handlePathname()
    },
  },
  methods: {
    toHomePage() {
      if (store.state.currentPage === 'val') {
        this.$router.push("/");
      } else if (store.state.currentPage === 'cs2') {
        this.$router.push("/cs2");
      } else {
        this.$router.push("/");
      }
    },
    handleWindowWidth() {
      this.isPhoneWidth = window.innerWidth <= PHONE_WIDTH;
    },
    handlePathname() {
      this.pathname = window.location.pathname
    },
    showPhoneMenu() {
      this.phoneMenuVisible = !this.phoneMenuVisible
    },
    handleCommand(command) {
      if (command === 'signOut') {
        this.signOut()
      }
      if (command === 'editProfile') {
        this.$router.push('/edit_profile')
      }
    },
    signOut() {
      QC.Login.signOut()
      delete axios.defaults.headers.common.Authorization
      localStorage.removeItem('token')
      this.$store.commit('resetState')
      location.reload()
    },
    openQQLogin() {
      localStorage.setItem('urlBeforeLogin', window.location.href)
      window.location = 'https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=102047093&redirect_uri=https://lkval.com/qqlogin'
    },
    getLiveStatus() {
      axios({
        method: 'get',
        url: '/api/blogs/is_live',
      }).then(r => {
        if (r.data.code === 0) {
          this.isLive = r.data.is_live
        }
      })
    },
    openLive() {
      window.open('https://live.bilibili.com/7982425')
    },
    selectGame(game) {
      if (game === 'cs2') {
        store.commit('setCurrentPage', 'cs2')
        localStorage.setItem('currentPage', 'cs2')
        // this.$router.push("/cs2");
      } else if (game === 'val') {
        store.commit('setCurrentPage', 'val')
        localStorage.setItem('currentPage', 'val')
        // this.$router.push("/");
      } else {
        store.commit('setCurrentPage', 'df')
        localStorage.setItem('currentPage', 'df')
        // this.$router.push("/");
      }
    },
    showFeedback() {
      this.feedbackDialogVisible = true;
    },
    submitFeedback() {
      if (!this.feedbackForm.content.trim()) {
        this.$message.error('请输入反馈内容');
        return;
      }
      axios({
        method: 'post',
        url: '/api/blogs/submit_comment',
        data: {
          comment: this.feedbackForm.content,
        }
      }).then(r => {
        if (r.data.code === 0) {
          // this.$message({
          //   message: '提交成功',
          //   type: 'success'
          // });
          // 模拟提交成功
          this.$message.success('反馈提交成功，感谢您的建议！');
          this.feedbackDialogVisible = false;
          // 重置表单
          this.feedbackForm = {
            content: ''
          };
        }
      })
    }
  }
}
</script>
x
<style scoped>

.header-container {
  background: #ffffff;
}

.header-wrapper {
  margin: 0 auto;
  height: 52px;
  min-width: 700px;
  display: flex;
  align-items: center;
}

.header-logo {
  margin-left: 40px;
  margin-right: 40px;
  font-size: 38px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header-log a {
  color: #000000;
}

.header-nav {
  margin: 0;
  height: 100%;
  display: flex;
  cursor: pointer;
}

.header-nav li {
  padding: 10px;
  display: flex;
  align-items: center;

  color: #bfdbfd;

  border-bottom: 2px white solid;
}

.header-nav li:hover {
  color: #4ba0fb;
  border-bottom: 2px #409eff solid;
}

.header-nav .header-nav-li-active {
  color: #4ba0fb;
  border-bottom: 2px #409eff solid;
}

.header-streamer-title {
  display: flex;
  flex-grow: 1;
  color: #b1b1b1;
}

.header-streamer-title a:hover {
  color: #4ba0fb;
  cursor: pointer;
}

.header-streamer-title-btn {
  padding: 2px 12px;
  font-size: 20px;
  border: 1px #ff4655 solid;
  border-radius: 3px;
  color: white;
  background: #ff4655;
  cursor: pointer;
}

.header-btn {
  margin-right: 40px;
  display: flex;
}

.header-btn-login {
  width: 80px;
  height: 32px;
  border: 1px #0066ff solid;
  border-radius: 3px;
  color: white;
  background: #0066ff;
  cursor: pointer;
}

.header-btn-is-login {
  margin-right: 40px;
}

.header-phone-wrapper {
  margin: 0 auto;
  height: 52px;
  display: flex;
  align-items: center;
}

.header-phone-logo {
  margin-left: 20px;
  font-size: 38px;
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.header-phone-menu {
  margin-right: 20px;
  font-size: 38px;
  width: 40px;
  height: 40px;
  border: 1px #000000 solid;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.header-phone-menu i {
  font-size: 30px;
  color: #000000;
}

.header-phone-nav {
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.header-phone-nav li {
  padding: 10px 0;
  display: flex;
  align-items: center;
  color: #000000;

  border-bottom: 2px #0f1923 solid;
}

.header-phone-nav li:hover {
  color: #000000;
  border-bottom: 2px #3f474f solid;
}

.header-phone-nav .header-nav-li-active {
  color: #000000;
  border-bottom: 2px #ff4655 solid;
}

.el-dropdown-link {
  cursor: pointer;
  color: #000000;
  display: flex;
  align-items: center;
}

.header-login-avatar {
  margin-right: 40px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.live-card {
  border: 1px solid #ff6699;
  border-radius: 4px;
  color: #ff6699;
  padding: 0 4px;
  cursor: pointer;
}

.live-card:hover {
  border: 1px solid #4ba0fb;
  color: #4ba0fb;
}

/* 按钮组样式 */
.game-switcher {
  margin-left: 20px;
  border-left: 1px solid #eee;
  padding-left: 20px;
}

.button-group {
  display: flex;
  background-color: #e2e6eb; /* 加深灰色背景 */
  border-radius: 8px; /* 稍微加大圆角 */
  padding: 4px; /* 增加内边距，让背景露出来 */
}

.switch-btn {
  border: none;
  background: transparent;
  padding: 6px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  color: #606266;
  transition: all 0.3s;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px; /* 图标和文字之间的间距 */
}

.game-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 4px; /* 如果图标是圆角的，这里可以调整 */
}

.switch-btn.active {
  background-color: #409eff;
  color: #fff;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
  font-weight: 600;
}

.switch-btn:hover:not(.active) {
  color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}

/* 外部链接按钮样式 */
.external-links {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
  border-left: 1px solid #eee;
  padding-left: 20px;
}

.external-link-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  background: transparent;
  border: none;
  cursor: pointer;
}

.external-link-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  vertical-align: middle;
}

.external-link-btn:hover {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.external-link-btn i {
  font-size: 16px;
}

/* 图标样式 */
.icon-bilibili {
  color: #fb7299;
}

.icon-qq {
  color: #12b7f5;
}
</style>